<template>
    <div class="content">

        <div class="intro" 
            v-bind:style="{
                backgroundImage: get_news_image(),
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundColor: 'black',
                backgroundPosition: 'center'
            }">

            <div class="overlay">

                <div class="wrapper">
                    <p class="subline">{{ news.subline }}</p>
                    <h1 class="headline">{{ news.title }}</h1>

                    <p class="description">
                        {{ news.short_description }}
                    </p>


                </div>

            </div>

        </div>    

        <div class="text__images">

            <div class="content__wrapper">

                <p class="news__date">{{ this.news.created_on }}</p>

                <div v-html="this.news.text" class="news__text"></div>

                <media-slider :media="this.news.media" :assetpath="'news'"></media-slider>

                <!-- <template v-if="all_news"> -->
                    <div class="more__news">

                        <p class="text">Get updated to our latest news</p>

                        <a class="anim_button" href="/news">
                            <p>MORE NEWS</p>
                            <div class="span_bg"></div>
                        </a>

                    </div>
                <!-- </template> -->

                <div class="social__media">

                    <p class="text">CHECK US OUT ON OUR SOCIAL NETWORKS:</p>

                    <div class="items">
                        <a class="link" href="https://www.facebook.com/GateTwentyOne/" target="_blank">
                            <img src="/images/icons/facebook.webp" alt="facebook"/>
                        </a>
                        <!-- <a class="link" href="">
                            <img src="/images/icons/instagram.webp"/>
                        </a> -->
                        <a class="link" href="https://www.linkedin.com/company/gate21doo" target="_blank">
                            <img src="/images/footer/li.webp" alt="linked in"/>
                        </a>
                    </div>

                </div>

            </div>

        </div>

        <template v-if="on_news_page()">
            <news-showcase :news="all_news" :featured="featured"></news-showcase>
        </template>
    </div>
</template>
<script>
    export default {
        data(){
            return {}
        },
        props: ['news', 'all_news', 'featured'],
        methods: {
            get_news_image(){
                return "url('" + '/image/' + this.news.media_path + '/' + this.news.featured_image + "')";
            },
            on_news_page(){
                if(window.location.pathname == "/news") return false;
                return true;
            }
        }
    }
</script>
<style lang="scss" scoped>

    .content{
        display: flex;
        flex-direction: column;

        .intro{
            position: relative;
            height: 490px;

            .overlay{
                display: block;
                width: 100%;
                height: 100%;
                position: relative;

                background: rgba(92, 44, 144, 0.6);

                .wrapper{
                    display: block;
                    position: absolute;
                    top: 57%; right: 50%;
                    transform: translate(50%, -50%);
                    // width: 976px;
                    width: 100%;
                    max-width: 1020px;
                    height: auto;

                    .subline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 14px;
                        line-height: 17px;
                        text-align: left;
                        text-transform: uppercase;

                        color: #ED1163;
                    }

                    h1.headline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 100px;
                        line-height: 100px;
                        /* or 100% */
                        margin: 0;
                        text-transform: uppercase;

                        color: #FFFFFF;

                        margin-left: -5px;
                    }

                    .description{
                        font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;;
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 18px;
                        line-height: 22px;

                        color: #FFFFFF;

                        margin: 0;
                        margin-top: 22px;
                        // text-align: center;
                        text-align: left;
                        width: 100%;
                        // max-width: 454px;
                        margin-left: 0;
                        margin-right: auto;

                        color: #FFFFFF;
                    }


                }

            }
        }


        .text__images{
            display: block;
            background: linear-gradient(360deg, #000000 0%, #2A1542 100%);

            .content__wrapper{
                display: flex;
                flex-direction: column;
                width: 100%;
                max-width: 990px;
                margin: 0 auto;

                .news__date{
                    font-family: 'DIN Next LT Pro Ultralight';
                    font-style: normal;
                    // font-weight: 300;
                    font-size: 12px;
                    line-height: 14px;
                    text-align: center;

                    color: #FFFFFF;
                    margin-top: 130px;
                    margin-bottom: 30px;
                }

                .news__text{
                    font-family: 'DIN Next LT Pro Ultralight';
                    font-style: normal;
                    // font-weight: 300;
                    font-size: 18px;
                    line-height: 22px;

                    color: #FFFFFF;

                    margin-bottom: 150px;
                }

                .more__news{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .text{
                        font-family: 'DIN Next LT Pro Bold';
                        font-style: normal;
                        font-size: 20px;
                        line-height: 24px;
                        margin: 0;
                        color: #FFFFFF;
                        text-align: center;
                        margin-bottom: 40px;
                    }

                    a.anim_button{
                        display: block;
                        background: rgba(15, 15, 15, 0.3);
                        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                        width: 409px;
                        height: 50px;
                        cursor: pointer;
                        user-select: none;
                        position: relative;
                        overflow-y: hidden;
                        z-index: 4;
                        text-decoration: none;
                        margin-left: auto;
                        margin-right: auto;
                        border: 1px solid #ED1163;

                        p{
                            font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            // font-weight: 700;
                            font-size: 20px;
                            line-height: 54px;
                            text-align: center;
                            letter-spacing: 0.2em;
                            text-transform: uppercase;
                            margin: 0 auto;

                            color: #FFFFFF;
                            position: relative;
                            z-index: 4;
                        }

                        div.span_bg{
                            background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                            height: 100%;
                            width: 100%;
                            transition: all .3s ease-in-out;
                            margin-top: auto;
                            margin-bottom: 0;
                            opacity: 0;

                            position: absolute;
                            bottom: -50px;
                            z-index: 3;
                        }

                        &:hover{
                            div.span_bg{
                                height: calc(100%);
                                bottom: 0;
                                opacity: 1;
                            }
                        }
                    }
                }

                .social__media{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    margin: 122px auto;

                    .text{
                        font-family: 'DIN Next LT Pro Bold';
                        font-style: normal;
                        font-size: 20px;
                        line-height: 24px;
                        margin: 0;

                        color: #FFFFFF;
                    }

                    .items{
                        display: flex;
                        flex-direction: row;
                        justify-content: center;

                        .link{
                            text-decoration: none;
                            margin: 24px 12px;

                            img{
                                width: 24px;
                                height: 24px;
                            }
                        }
                    }
                }
            }

        }
    }


    :deep(a) {
        color: white;
        font-weight: bold;
    }


    @media screen and (max-width: 836px) {

        .content{

            .intro{
                
                .overlay{

                    .wrapper{
                        width: 95%;
                        margin: auto;

                        .subline{
                            font-size: 20px;
                            line-height: 24px;
                            text-align: center;
                            margin-bottom: 15px;
                        }

                        h1.headline{
                            font-size: 40px;
                            line-height: 40px;
                            text-align: center;
                        }

                        .keywords{
                            font-size: 16px;
                            line-height: 16px;
                        }

                        .description{
                            text-align: center;
                        }

                        a.anim_button{
                            width: 100%;
                            max-width: 245px;
                            height: 35px;
                            
                            p{
                                font-size: 12px;
                                line-height: 40px;
                            }
                        }
                    }

                    .bottom__bar{
                        .text-wrap{
                            .red_text, .regular_text, .red_text.second{
                                font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                                font-size: 18px;
                                line-height: 25px;
                            }   
                        }
                    }
                }
            }

            .text__images{
                .content__wrapper{
                    width: 90%;

                    .news__date{
                        margin-top: 54px;
                    }

                    .news__text{
                        font-size: 16px;
                        line-height: 16px;
                        margin-bottom: 0;
                    }

                    .more__news{

                        a.anim_button{
                            width: 100%;

                            background: rgba(0, 0, 0, 0.6);
                            border: 1px solid #ED1163;
                            height: 31px;
                            margin-left: auto;
                            margin-right: auto;
                            width: 100%;

                            p{
                                font-size: 12px;
                                line-height: 33px;
                            }
                        }
                    }

                    .social__media{
                        .text{
                            text-align: center;
                        }
                    }
                }
            }
        }

       
    }


</style>